import React from 'react';

const FooterLogo = () => (
  <div className="logo-block__logo" data-testid="footer-logo">
    <span className="logo" aria-hidden="true" />
  </div>
);

export default FooterLogo;
